module.exports = "<!-- <section [ngClass]=\"this.router.url == '/login'? 'page-section-bg' : 'page-section'\"> -->\r\n<ng4-loading-spinner> </ng4-loading-spinner>\r\n<section>\r\n    \r\n    <div *ngIf=\"router.url != '/login'\" class=\"sideBarDiv\"><app-header *ngIf=\"router.url != '/login'\"></app-header></div>\r\n    \r\n    <div ng-sidebar-content class=\"sideBarContent\" [style.left]=\"router.url == '/login'? '0' : margin\"  [style.width]=\"width\">\r\n        \r\n    <router-outlet></router-outlet>\r\n</div>\r\n    \r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shell/shell.component.html
// module id = ./src/app/shell/shell.component.html
// module chunks = main